<template>
  <svg class="w-6 h-6 text-gray-800" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <!-- Feuille -->
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4h16v16H4V4z" />
    <!-- Graphique -->
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 14v-4m4 4V10m4 4v-2" />
    <!-- Bordure haut feuille -->
    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4l16 0 0 4" />
  </svg>
</template>

<script>
export default {
  name: "ReportIcon",
};
</script>
